module.exports = __webpack_public_path__ + "static/media/cS-2.b75541df.jpg";